module.exports = __webpack_public_path__ + "img/events-bg.5e399d03.jpeg";